import {getWebsiteId} from "./getWebsiteId";
import {isDevEnvironment} from "./isDevEnvironment";

const WEBSITE_URLS = {
  1: "https://forthwithlife.co.uk",
  2: "https://sportsbloodtests.co.uk",
};

const siteId = getWebsiteId();

export const getWebsiteUrl = websiteId => {
  if (isDevEnvironment) {
    return window.location.hostname.includes("sportsbloodtests.co.uk") ? WEBSITE_URLS[2] : WEBSITE_URLS[1];
  }

  if (websiteId) return WEBSITE_URLS[websiteId] ?? window.location.origin;
  return WEBSITE_URLS[siteId] ?? window.location.origin;
};
